export const API_URL = "/api";
export const API_TEST_URL = "/api/test";
export const API_BLINK_URL = "/api/blink";
//export const API_URL = "/api";
